import React, {useEffect, useState} from 'react';
import {DEFAULT_PAGE_SIZE, ORDER_BY} from '@app/constants/Common';
import {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {requestGetCddNeedFuList} from "@app/services/CddNeedFuService";
import CddNeedFuListTable from "@pages/candidate/cddneedfu/CddNeedFuListTable";
import * as CandidateService from '@app/services/CandidateService';

const CddNeedFuList = (props) => {
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [personal, setPersonal] = useState({});

    const [orderBy, setOrderBy] = useState(ORDER_BY.DESC_UPDATE_DATE);

    let cddRecId = ''
    if (props.location && props.location.search) {
        cddRecId = new URLSearchParams(props.location.search).get("cdd_rec_id")
    }

    const fetchPersonal = async (canId) => {
        const res = await CandidateService.getCandidatePersonalDetail(canId)
        setPersonal(res.content)
    };

    const searchCandidates = () => {
        requestGetCddNeedFuList({cdd_rec_id: cddRecId}).then((res) => {
            setCandidates(res.content.candidates);
            setAllCandidateIds(res.content.all_candidate_ids);
            setTotalCount(res.content.totalCount)
            setCurrentPage(res.content.page)
            setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
        })
    }

    useEffect(() => {
        if (cddRecId) {
            searchCandidates()
            fetchPersonal(cddRecId)
        }
    }, []);

    return (
        <div className='container-fluid'>
            <div className='card card-default'>
                <div className='card-header'>
                    <div className='card-title text-bold w-100'>{'List Cdd cần FU'}</div>
                    <a className='w-100' href={`/candidate/detail/${cddRecId}`}
                     rel='noopener noreferrer' target='_blank' >
                        {`Cdd Receiver: ${personal.full_name || ''} - ID: ${cddRecId}`}
                    </a>
                    <div className='card-tools'>
                        {/*<a href='#'*/}
                        {/*        className=''*/}
                        {/*        onClick={() => {*/}
                        {/*            setShowSearchInputModal(true)*/}
                        {/*        }}>*/}
                        {/*    <i className='fas fa-filter mr-2'/>*/}
                        {/*</a>*/}
                    </div>
                </div>
                <div className='card-body'>
                    <div style={{position: 'relative'}}>
                        {/*<SearchConditionInputModal isShow={showSearchInputModal}*/}
                        {/*                           onSearch={(searchInput) => searchCandidates(currentPage, orderBy, searchInput)}*/}
                        {/*                           onClose={() => setShowSearchInputModal(false)} />*/}
                        <CddNeedFuListTable candidates={candidates}
                                            onSearchCandidates={
                                                (page, searchOrderBy) => searchCandidates(page, searchOrderBy)}/>
                        {isLoading &&
                        <div className={'col-sm-12 text-center'}
                             style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                            <div className='spinner-grow text-primary' role='status'>
                                <span className='sr-only'>Loading...</span>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CddNeedFuList;
